var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RolChip',{attrs:{"clickable":""},on:{"click":function($event){return _vm.filter(("rol:" + (_vm.rol.slug)))}},model:{value:(_vm.rol),callback:function ($$v) {_vm.rol=$$v},expression:"rol"}})}
var staticRenderFns = []

export { render, staticRenderFns }